import React from 'react'
import { CustomDialog } from '../../components'
import { Box } from '@mui/material'
import closureDocument from '../../assets/Images/closureDocument.svg'
import { useStyles } from './style'

const ProgramClosureModal = (props) => {
  const classes = useStyles()
  const getProgramClosureContent = () => (
    <Box display="flex" justifyContent="center" flexDirection="column" mx={4} mb={2}>
      <Box display="flex" justifyContent="center" width="100%"><img src={closureDocument} className={classes.programClosureImage} alt="program closure" /></Box>
      <Box className={classes.programClosureTitle}>Sorry! Not accepting applications anymore</Box>
      <Box className={classes.programClosureDescription}>
        <Box>APS has closed the Residential Battery Program and is no longer accepting new applications.</Box>
        <Box mb={2}>Customer applications currently under review will continue to be processed. If an application is deemed ineligible by APS, Enphase will notify the installer and customer. APS may potentially reopen this or a similar program to new applications at a later date, though this has not yet been confirmed.</Box>
        <Box>If you have any questions related to applications submitted and under review, please contact <b>gridservicessupport@enphaseenergy.com</b></Box>
      </Box>
    </Box>
  )

  return (
    <CustomDialog open={props.programClosureModal} content={getProgramClosureContent()} handleClose={() => props.handleClose(false)} />
  )
}

export default ProgramClosureModal